import React from "react";

export default function DoctorCard({ doctor, onClick }) {
  return (
    <button
      className="doctor-card"
      onClick={onClick}
      aria-label={`${doctor.name} 詳細資訊`}
    >
      <img className="doctor-photo" src={doctor.photo} alt={doctor.name} />
      <div className="doctor-meta">
        <div className="doctor-name">{doctor.name}</div>
        <div className="doctor-brief">{doctor.brief}</div>
      </div>
    </button>
  );
}
